import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetRanchesQuery } from '../impl/blfApi/endpoints/ranches';

export const useRanchesByCustomer = (
  customerId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!customerId || queryOptions?.skip) {
      return skipToken;
    }

    return { customer__id__in: [customerId ?? ''] };
  }, [customerId, queryOptions?.skip]);

  const {
    data: ranches,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    isUninitialized,
  } = useGetRanchesQuery(queryParams, queryOptions);

  return {
    ranches,
    isRanchesLoading: isLoading || isFetching,
    isSuccess,
    isError,
    isUninitialized,
  };
};
